"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TabList: function() {
        return _TabList.TabList;
    },
    TabListContext: function() {
        return _TabListContext.TabListContext;
    },
    TabListProvider: function() {
        return _TabListContext.TabListProvider;
    },
    renderTabList_unstable: function() {
        return _renderTabList.renderTabList_unstable;
    },
    tabListClassNames: function() {
        return _useTabListStylesstyles.tabListClassNames;
    },
    useTabListBase_unstable: function() {
        return _useTabList.useTabListBase_unstable;
    },
    useTabListContextValues_unstable: function() {
        return _useTabListContextValues.useTabListContextValues_unstable;
    },
    useTabListContext_unstable: function() {
        return _TabListContext.useTabListContext_unstable;
    },
    useTabListFocusAttributes: function() {
        return _useTabList.useTabListA11yBehavior_unstable;
    },
    useTabListStyles_unstable: function() {
        return _useTabListStylesstyles.useTabListStyles_unstable;
    },
    useTabList_unstable: function() {
        return _useTabList.useTabList_unstable;
    }
});
const _TabList = require("./TabList");
const _TabListContext = require("./TabListContext");
const _renderTabList = require("./renderTabList");
const _useTabList = require("./useTabList");
const _useTabListContextValues = require("./useTabListContextValues");
const _useTabListStylesstyles = require("./useTabListStyles.styles");
